export default "__VITE_ASSET__HViiTePl__"